// Primary keywords list for an AI writing tool
export const aiWritingKeywords = {
  // Core product keywords
  core: [
    "ai writing assistant",
    "personalized writing tool",
    "long-form writing ai",
    "voice-adaptive ai writer",
    "ai content creation tool",
    "ai writing platform",
    "automated writing assistant",
    "context-aware writing software",
    "ai writing co-pilot",
    "tone-aware content generator",
  ],

  // Feature-specific keywords
  features: [
    "newsletter writing ai",
    "essay writing assistant",
    "ai for blog writing",
    "voice memo to text tool",
    "ai topic suggestion tool",
    "contextual autocomplete ai",
    "ai research assistant",
    "paragraph rewriter ai",
    "ai draft editor",
    "personal tone learning ai",
  ],

  // Benefit-focused keywords
  benefits: [
    "write faster with ai",
    "accurate content generation",
    "maintain writing style",
    "overcome blank page",
    "cohesive writing support",
    "time-saving content tool",
    "human-like ai writing",
    "scalable content workflow",
    "tone-consistent writing",
    "streamlined writing process",
  ],

  // Industry-specific keywords
  industries: [
    "ai for content creators",
    "ai for newsletter writers",
    "ai for students",
    "ai for bloggers",
    "ai for solo founders",
    "academic writing automation",
    "ai for content marketers",
    "ai writing tool for education",
    "ai for independent publishers",
    "startup writing assistant",
  ],

  // Technical keywords
  technical: [
    "gpt writing assistant",
    "language model writing tool",
    "natural language generation ai",
    "ai tone adaptation",
    "contextual ai writing model",
    "semantic text generation",
    "machine learning writing app",
    "transformer-based writing",
    "generative ai platform",
    "fine-tuned ai content tool",
  ],

  // Competitive keywords
  competitive: [
    "alternative to jasper ai",
    "alternative to copy ai",
    "better than lex.page",
    "ai writing tool comparison",
    "ai writing assistant for creators",
    "best ai for essays",
    "top ai newsletter tool",
    "professional writing ai",
    "affordable ai content assistant",
    "custom ai writing solution",
  ],

  // User-intent keywords
  userIntent: [
    "how to write articles with ai",
    "ai for writing in your voice",
    "turn voice notes into writing",
    "generate essays with ai",
    "get ai help with writing",
    "use ai for research and drafting",
    "write newsletters faster",
    "ai writing that sounds human",
    "best ai for student writing",
    "ai writing tool that learns tone",
  ],
};

// Function to generate comma-separated keywords string for meta tags
export const generateKeywordsMetaTag = (
  categories: string[] = ["core", "features", "benefits"],
  count: number = 5
): string => {
  let selectedKeywords: string[] = [];

  categories.forEach((category) => {
    if (aiWritingKeywords[category]) {
      // Select random keywords from each category up to the count
      const categoryKeywords = aiWritingKeywords[category]
        .sort(() => 0.5 - Math.random())
        .slice(0, count);

      selectedKeywords = [...selectedKeywords, ...categoryKeywords];
    }
  });

  // Shuffle and limit the final list
  return selectedKeywords
    .sort(() => 0.5 - Math.random())
    .slice(0, count * categories.length)
    .join(", ");
};
